import { ColumnHelper } from '@tanstack/react-table';
import { CustomFieldDisplayValue } from 'components/custom-fields';
import { TruncatedText } from 'components/truncated-text';
import { EmptyData } from 'components/util';
import { Contact, CustomField } from 'types/domain';

const getCustomFieldColumnKey = (field: CustomField) => `cf_${field.id.toString()}`;

const configureCustomFieldColumn = (
    customField: CustomField,
    columnHelper: ColumnHelper<Contact>,
) =>
    columnHelper.display({
        id: getCustomFieldColumnKey(customField),
        header: () => (
            <div className={'flex max-w-[200px]'}>
                <TruncatedText>{customField.title}</TruncatedText>
            </div>
        ),
        enableSorting: false,
        cell: info => {
            const response = info.row.original.custom_field_responses.find(
                f => customField.id === f.field_id,
            );

            const field = { ...customField, response };

            if (!response) return <EmptyData />;
            return <CustomFieldDisplayValue key={customField.id} field={field} />;
        },
        meta: {
            ignoreLink: customField.type === 'file',
        },
    });

export { getCustomFieldColumnKey, configureCustomFieldColumn };
